import { Component, OnInit, Input, OnChanges, AfterViewInit, OnDestroy, ViewChild, SimpleChanges } from '@angular/core';
import { SortModel } from "../../shared/sort.model";
import { PageSizeSelectionComponent } from "../../shared/page-size-selection.component";
import { ReportsService } from "../reports.service";
import { FileSaverService } from "../../shared/file-saver.servive";
import { DropdownValue } from "../../shared/dropdown.model";
import { IFillReportViewModel } from "./fill-report.model";
import { FillReportSortField } from "./fill-report-sort.enum";
import { CustomHorizontalScrollService } from "../../shared/custom-horizontal-scroll.service";
import { SortService } from '../../shared/sort.service';
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';

@Component({
    moduleId: module.id,
    selector: 'fill-report',
    templateUrl: 'fill-report.component.html'
})

export class FillReportComponent implements OnChanges, AfterViewInit, OnDestroy {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() fileName: string;
    data: IFillReportViewModel[];
    showOverlay: boolean = true;
    pageNumber: number = 1;
    totalCount: number;
    pageSize: number = 0;
    publisherSort: SortModel = new SortModel(FillReportSortField.Publisher, SortModel.disabledIcon);
    countrySort: SortModel = new SortModel(FillReportSortField.Country, SortModel.disabledIcon);
    requestsSort: SortModel = new SortModel(FillReportSortField.Requests, SortModel.disabledIcon);
    contentReadySort: SortModel = new SortModel(FillReportSortField.ContentReady, SortModel.disabledIcon);
    fillSort: SortModel = new SortModel(FillReportSortField.Fill, SortModel.descIcon);
    useLightClass: boolean = true;
    private sortDirectionAsc: boolean = false;
    private sortField: SortModel;
    private inXhrGetFillReports: any;
    disableCsvButton: boolean = false;
    disableExcelButton: boolean = false;

    @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent

    constructor(
        private reportsService: ReportsService,
        private fileSaverService: FileSaverService,
        private scrollService: CustomHorizontalScrollService,
        private sortService: SortService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.sortField = this.fillSort;
        if (this.data)
            this.getFillReports(1);
    }

    ngOnDestroy(): void {
        if (this.inXhrGetFillReports) {
            this.inXhrGetFillReports.unsubscribe();
        }
        this.scrollService.toggleHorizontalScroll(false);
    }
    ngAfterViewInit(): void {
        this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
        this.getFillReports(1);
    }

    onResize(event) {
        this.toggleHorizontalScroll();
    }

    private toggleHorizontalScroll() {
        let self = this;
        setTimeout(function () {
            self.scrollService.toggleHorizontalScroll();
        }, 10);
    }

    onPageSizeChanged(item: DropdownValue) {
        this.pageSize = item.value;
        this.pageNumber = 1;
        this.getFillReports(this.pageNumber);
    }

    onSortChanged(sort: SortModel) {
        let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
        this.sortField = sortResult.existingSortModel;
        sort = sortResult.selectedSortModel;
        this.sortDirectionAsc = sortResult.sortDiresctionAsc;
        
        this.getFillReports(1);
    }

    downloadCsv(event: any) {
        event.preventDefault();
        this.disableCsvButton = true;
        let fileName = `${this.fileName} Fill`;
        let file = `${fileName}.csv`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.Fill, FileType.Csv).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableCsvButton = false; }
        );
    }

    downloadExcel(event: any) {
        event.preventDefault();
        this.disableExcelButton = true;
        let fileName = `${this.fileName} Fill`;
        let file = `${fileName}.xlsx`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.Fill, FileType.Excel).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableExcelButton = false; }
        );
    }

    public getFillReports(page: number): void {
        if (this.inXhrGetFillReports) {
            this.inXhrGetFillReports.unsubscribe();
        }
        this.showOverlay = true;
        this.inXhrGetFillReports = this.reportsService.getFillReports(this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.startDate, this.endDate)
            .subscribe((res: any) => {
                this.data = <IFillReportViewModel[]>res.json().data;
                this.totalCount = res.json().total;
                this.pageNumber = page;
            },
                () => { },
                () => { this.showOverlay = false; this.toggleHorizontalScroll(); }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/reports/fill-report/fill-report.component.ts